import OBase from './OBase';

import * as Geometry from '../geometry';

export default class MassMultiplication extends OBase {
  update () {
    let valTree = this.getFloatInput('Input');
    let rOutput = this.getGenericObjectOutput('Result');
    let pOutput = this.getGenericObjectOutput(('Partial Results'));

    var outTree1 = new Geometry.DataTree();
    var outTree2 = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      var valList = valTree.branches[i];
      if (valList.length > 0) {
        var floatVal = 1.0;

        for (let j = 0; j < valList.length; j++) {
          var val = valList[j];
          floatVal *= val;
          outTree2.add(floatVal, valTree.paths[i]);
        }

        outTree1.add(floatVal, valTree.paths[i]);
      }
    }

    rOutput.value = outTree1;
    pOutput.value = outTree2;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/MassMultiplication.js